import React, { useState, useContext, useEffect } from 'react'
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Button, InputGroup, InputGroupText, Alert, } from "reactstrap";
import { AppContext } from '../../AppContext';
import Logo from '../../assets/img/inspectalyLogo.png'
import axios from 'axios';
import { BASE_URL } from '../../constants';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [errMsg, setErrMsg] = useState(null);
    const { updateUserData } = useContext(AppContext);
    const [visible, setVisible] = useState(false);

    // const handleLogin = () => {
    //     if (email != '' && pass != '') {
    //         const userData = {
    //             email: email,
    //             password: pass
    //         };
    //         updateUserData(userData);
    //     } else {
    //         setErrMsg('Please fill in all fields');
    //     }
    // };

    const handleForgotPassword = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/auth/forgot-password`, {
                email: email,
            });

            console.log(response.data.result, 'pak')
            if (response.data.status) {
                setErrMsg(response.data.message);

            }
            else {
                setErrMsg(response.data.message);
            }

        } catch (error) {
            setErrMsg(error);
        }

    };

    const show = () => {
        if (visible === false) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     if (token) {

    //         navigate('/dashboard');
    //     }
    // }, []);

    return (
        <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '5%' }} >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={Logo} alt="Logo" width="250" height="auto" draggable="false" />
            </div>
            <Card
                style={{
                    width: '90%',
                    maxWidth: '30rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    padding: '20px',
                    paddingBottom: '40px',
                }}>
                {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                <CardBody>
                    <CardTitle tag="h3" className='text-center mb-4'>
                        Forgot Password
                    </CardTitle>
                    <CardTitle>Email</CardTitle>
                    <InputGroup>
                        <input type="email" className="form-control user-select-none" autoFocus
                            value={email} onChange={(e) => setEmail(e.target.value)} />
                    </InputGroup>

                </CardBody>

                <CardFooter className=''>
                    <Row className='text-center'>
                        <Col >
                            <Button color="primary" className='px-5' size="md" onClick={handleForgotPassword} >Confirm</Button>
                        </Col>
                    </Row>
                </CardFooter>
            </Card>

        </div>
    )
}

export default ForgotPassword
